
export const getClipById = ({ id, cliplist }) => {
    let found = false;
    if (id && cliplist && cliplist.length) {
        const found = cliplist.find(item => +item.id === +id);
        if (found) return found;
    }
    return found;
}